import styled from '@emotion/styled';

const OfferSetupGrid = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 30% 1fr;
  grid-column-gap: var(--spacing);

  > * {
    min-width: 0;
  }

  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
    grid-row-gap: var(--spacing-lg);
  }
`;

export default OfferSetupGrid;
